"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const core_1 = require("@emotion/core");
const common_utils_1 = require("@zapier/common-utils");
const EditorAnnouncementBannerCss = core_1.css({
    borderBottom: `1px solid ${theme_1.Colors.adamantium}`,
    backgroundColor: theme_1.Colors.white,
    color: design_system_1.Colors.black,
    padding: 10,
    width: '100%',
    textAlign: 'center',
    a: {
        color: design_system_1.Colors.blue500,
        textDecoration: 'underline',
    },
});
const EditorAnnouncementBanner = (props) => {
    return (common_utils_1.isolateComponent("div", { css: EditorAnnouncementBannerCss },
        props.message,
        ' ',
        common_utils_1.isolateComponent("a", { href: "/zap-sharing", onClick: props.onLearnMore, target: "_blank" }, "Learn More"),
        "."));
};
exports.default = EditorAnnouncementBanner;
